<template>
  <div class="w-full">
    <div >
      <div style="display: flex; align-items: center" class="py-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="69"
          fill="none"
          viewBox="0 0 64 69"
        >
          <path
            fill="#b3e5fc"
            d="M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z"
          />
          <path
            fill="#E56353"
            d="M34.96 10.802h-5.84c-3.581 0-6.218 3.353-5.372 6.833l1.67 6.881c.336 1.38.917 2.689 1.716 3.863 1.336 1.962 2.05 4.28 2.05 6.654v1.689h5.712v-1.69c0-2.373.714-4.691 2.05-6.653.799-1.175 1.38-2.483 1.715-3.863l1.671-6.88c.846-3.481-1.79-6.834-5.372-6.834z"
          />
          <path
            fill="#64798A"
            d="M27.738 36.722h8.605c.626 0 1.133.507 1.133 1.133v3.288H26.604v-3.288c0-.626.508-1.133 1.134-1.133z"
          />
          <path
            fill="#DC8744"
            d="M16.214 41.143h31.652c.626 0 1.134.508 1.134 1.134v8.056c0 .313-.254.567-.567.567H15.647c-.313 0-.567-.254-.567-.567v-8.056c0-.626.508-1.134 1.134-1.134z"
          />
          <path
            fill="#3A556A"
            d="M17.823 50.9h28.435v1.273c0 .626-.508 1.134-1.134 1.134H18.956c-.626 0-1.133-.508-1.133-1.134V50.9z"
          />
          <path
            fill="#404B58"
            d="M23.738 46.618c-.385 0-.697-.311-.697-.696v-1.367c0-.385.312-.696.697-.696.384 0 .696.311.696.696v1.367c0 .385-.311.696-.696.696zM40.052 46.618c-.385 0-.697-.311-.697-.696v-1.367c0-.384.312-.696.697-.696.385 0 .696.312.696.696v1.367c0 .385-.312.697-.696.697zM31.937 47.67c-1.033 0-2.016-.448-2.696-1.229-.253-.29-.222-.73.068-.982.29-.253.73-.223.982.067.416.477 1.015.75 1.646.75.63 0 1.23-.273 1.646-.75.253-.29.692-.32.982-.067.29.252.32.692.068.982-.68.78-1.663 1.228-2.696 1.228z"
          />
          <path
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M48.832 59.043l2.943 3.107 6.306-6.659"
          />
        </svg>
        <h1 class="text-2xl my-4 text-600 pl-6 mr-4 font-medium">
          {{
            $t(
              `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.descriptionSelect`
            )
          }}
        </h1>
      </div>
      <hr class="w-full border custom-hr mb-3" />
      <div class="overflow-auto " style="max-height: 24rem">
        <div v-if="loading" style="min-height: 10rem">
         <vue-element-loading :active="loading" spinner="spinner" color="#4F41A3" />
         </div>
        <div
          v-for="(certificate, index) in certificatesList"
          :key="index"
          class="mb-1 pt-1"
        >
          <div
            class="
              flex
              justify-center
              items-center
              m-2
              bg-white
              border-rounded border-gray-400
            "
          >
            <div class="mr-1 p-4">
             <div class="m-1 mr-2 w-12 h-12 relative flex justify-center items-center rounded-full bg-blue-400 text-xl text-white uppercase">{{getInitials(certificate.full_name)}}</div>
            </div>

            <div class="w-full">
              <p class="text-lg mb-1 font-semibold">
                {{ certificate.full_name }}
              </p>
              <p class="text-sm">{{ certificate.company_name }}</p>
            </div>
            <div class="flex flex-col">
              <zt-button
                outlined
                class="mr-2 font-medium w-4/5"
                data-vs-button="select-certificate"
                @click="selectCertificate(certificate.id)"
              >
                {{
                  $t(
                    `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.buttonSelect`
                  )
                }}
              </zt-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Certificates from "@/apiClient/Certificates";
import VueElementLoading from "vue-element-loading";
export default {
  name: "SelectCertificateModalBody",
  components: {
    VueElementLoading
  },
  data() {
    return {
      certificatesList: [],
      cert: "",
      selectedCertificate: {},
      loading: false
    };
  },

  created() {
    this.cert = new Certificates();
    this.getCerts();
  },
  methods: {
    getCerts() {
      this.loading = true
      this.cert.getSignCertificatesEnabled()
      .then((response) => {
        this.certificatesList = response.data.data;
        this.loading = false
      })
      .catch(error => {
        this.loading = false })
    },
    selectCertificate(id) {
      this.selectedCertificate = this.certificatesList.find(
        (element) => element.id === id
      );
      this.$emit("certificate-change-step", 2, this.selectedCertificate);
    },
    getInitials(name) {
      let names = name.trim().split(' ')
      let initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
    }
  },
};
</script>

<style lang="scss" scoped>
.custom-hr{
  margin-left: -20px;
  width: 120%;
  background-color: rgba(128, 128, 128, 0.879);
}
</style>
